const AccountList = () => import('Views/account/account-list');
const AccountAddEdit = () => import('Views/account/account-addEdit');
const AccountDetail = () => import('Views/account/account-detail');

export default[
  { path: '/account-list', component: AccountList },
  { path: '/account-add', component: AccountAddEdit },
  { path: '/account-edit/:id', component: AccountAddEdit },
  { path: '/account-detail/:id', component: AccountDetail },
];



// WEBPACK FOOTER //
// ./src/router/account.js